(() => {
    $('#thumblist').owlCarousel({
        navigation: true,
        items: 6,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 4],
        itemsTablet: [768, 4],
        itemsTabletSmall: [540, 4],
        itemsMobile: [360, 4],
        afterInit: circleProportion
    });
    function circleProportion(el){
        const thumb = document.getElementById('thumbs_list');
        thumb.style.opacity = 0;
        setTimeout(() => {
            const els = el[0].querySelectorAll('.owl-item');
            let width;
            for (const item of els) {
                if(!width && item.style.width) width = item.style.width;
                if(!item.style.width) item.style.width = width;
                item.style.height = (parseInt(width.replace('px','')) - 4) + 'px';
            }
            thumb.style.opacity = 1;
        },1000);
    }

    $('.thumbs_list_frame').height(parseInt($('.thumbs_list_frame >li').outerHeight(true) * $('.thumbs_list_frame >li').height) + 'px');
    $('.thumbs_list').serialScroll({
        items: 'li:visible',
        prev: '.view_scroll_left',
        next: '.view_scroll_right',
        axis: 'y',
        start: 0,
        stop: true,
        duration: 700,
        step: 2,
        lazy: true,
        lock: false,
        force: false,
        cycle: false
    });
    if (!!$.prototype.fancybox) {
        $('li:visible .fancybox, .fancybox.shown').fancybox({
            'hideOnContentClick': true,
            'openEffect': 'elastic',
            'closeEffect': 'elastic'
        });
    }
})();

function hideSyndigoElement() {
    const syndi_elem = document.getElementById('syndigo-mediamarkt/pt-hotspots');
    if (syndi_elem && syndi_elem.parentElement.classList.contains("imglist")) {
        syndi_elem.style.width = 0;
        syndi_elem.style.height = 0;
    }
}

window.addEventListener('load', function () {
    setTimeout(hideSyndigoElement, 500)
})